import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import {
    DeviceManagementConfigurationPolicy,
    DeviceManagementConfigurationPolicyAssignment,
    DeviceManagementConfigurationSetting,
} from '@microsoft/microsoft-graph-types-beta';
import { BaseComponent } from '../../../../base/base.component';
import * as DeviceConfigurationWindowsEdgeBlockPasswordSaving from 'projects/angular-clarity/src/app/modules/sway/tools/schemas/graph/intune/configuration-policy/windows-edge-block-password-saving';
import { DeviceConfigurationWindowsEdgeBlockPasswordSavingSchema } from 'projects/angular-clarity/src/app/modules/sway/tools/schemas/graph/intune/configuration-policy/windows-edge-block-password-saving/model';
import {
    getPolicyItemSettingValueFromData,
    ConfigurationPolicySettingNames,
} from 'projects/angular-clarity/src/app/modules/sway/tools/schemas/graph/intune/configuration-policy/helper';
@Component({
    selector: 'app-baseline',
    templateUrl: './baseline.component.html',
    styleUrls: ['./baseline.component.scss', '../../../../styles/baseline-style.scss'],
})
export class BaselineComponent extends BaseComponent implements OnInit, OnChanges {
    currentEdgeSyncDisabled: string;
    currentPasswordManagerEnabled: string;
    tooltips = DeviceConfigurationWindowsEdgeBlockPasswordSaving.tooltips;
    constructor(private fb: FormBuilder) {
        super();
    }

    policy: DeviceManagementConfigurationPolicy;
    assignments: DeviceManagementConfigurationPolicyAssignment[] = [];
    settings: DeviceManagementConfigurationSetting[] = [];
    ngOnInit(): void {
        this.getData();
        const schema = JSON.parse(JSON.stringify(this.baseline.schema));

        this.initForm(schema);
        this.observeFormChange();
    }

    ngOnChanges(_changes: SimpleChanges): void {
        this.getData();
    }

    getData() {
        if (this.data.length > 0) {
            this.policy = this.data?.[0];
            this.assignments = this.policy?.assignments || [];
            this.settings = this.policy?.settings || [];

            this.currentEdgeSyncDisabled = getPolicyItemSettingValueFromData(
                this.settings,
                ConfigurationPolicySettingNames.edgeSyncDisabled,
            );

            this.currentPasswordManagerEnabled = getPolicyItemSettingValueFromData(
                this.settings,
                ConfigurationPolicySettingNames.edgePasswordManagerEnabled,
            );
        }
    }

    observeFormChange() {
        const schema: DeviceConfigurationWindowsEdgeBlockPasswordSavingSchema = JSON.parse(
            JSON.stringify(this.baseline.schema),
        );

        this.form.valueChanges.subscribe((res) => {
            const updatedSchema = DeviceConfigurationWindowsEdgeBlockPasswordSaving.updateSchema(
                this.formValue,
                schema,
            );

            const noGroupAssignments = updatedSchema.contains.properties.assignments?.maxItems === 0;

            if (noGroupAssignments) {
                this.baselineErrorChange.next({ remediate: true, save: true });
            } else {
                this.baselineErrorChange.next({ remediate: false, save: false });
            }

            this.baselineChange.next({
                ...this.baseline,
                schema: JSON.parse(JSON.stringify(updatedSchema)),
            });
        });
    }

    initForm(schema: DeviceConfigurationWindowsEdgeBlockPasswordSavingSchema): void {
        this.form = DeviceConfigurationWindowsEdgeBlockPasswordSaving.initForm(schema, this.fb);
    }

    get desiredSettingsControl(): FormGroup {
        return this.form.get('settings') as FormGroup;
    }

    get desiredSettingsValue() {
        return this.desiredSettingsControl?.value || {};
    }

    get desiredPolicyControl(): FormGroup {
        return this.form.get('policy') as FormGroup;
    }

    get desiredPolicyValue() {
        return this.desiredPolicyControl.value;
    }

    get desiredAssignmentsControl(): FormGroup {
        return this.form.get('assignments') as FormGroup;
    }

    get formValue() {
        return this.form.getRawValue();
    }
}
